import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IWorkOrder, IWorkOrderComment } from "@/models";

@Component({
    name: "workordercomments",
})

export default class WorkOrderComments extends Vue {
    public comment: string;

    @Prop({ required: true, type: Number })
    public workOrderId: number;

    public get workOrder(): IWorkOrder {
        return this.$store.getters["productionLines/getWorkOrderById"](this.workOrderId);
    }

    constructor() {
        super();

        this.comment = "";
    }

    public getHtmlComment(woComment: IWorkOrderComment): string {
        return woComment.comment.replace(/\n/g, "<br />");
    }

    public async addWorkOrderComment(): Promise<void> {
        await this.$store.dispatch("productionLines/addWorkOrderComment", { workOrderId: this.workOrderId, comment: this.comment });
        this.comment = "";
    }
}
